import React from 'react'
import Description from 'components/Slides/Description'

export default Description({
  description: () => (
    <div>
      <p>
        Firstly, let’s go back to our shopping list to work out what we’re going
        to do this week…
      </p>
    </div>
  ),
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/02-back-to-list.js